import { CheckoutHeader } from "@aitisal/ui/common/CheckoutHeader";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import AppLayout from "../../components/AppLayout";
import CheckoutFooter from "../../components/Footer/CheckoutFooter";
import { useRestuarantDetails } from "../../stores/stores";
import { useBrandingConfig } from "../../utils/brandingConfig";
import CheckOut from "../../screens/checkout";
// The checkout route mounts only shared pieces (no theme slots), so the
// classic stylesheet — normally bundled with the lazy classic theme chunk —
// would never load on a direct entry / refresh here. Import it statically;
// all of its rules are scoped to html[data-theme="classic"], so they are
// inert for the other themes.
import "../../themes/classic/theme.css";
// Same for the default theme — its checkout chrome rules are scoped to
// [data-theme="default"][data-checkout], so they are inert elsewhere.
import "../../themes/default/theme.css";

export const Route = createFileRoute("/c/checkout")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const { restaurant } = useRestuarantDetails();
  const brandingConfig = useBrandingConfig();

  return (
    <AppLayout>
      <CheckoutHeader
        logoSrc={brandingConfig.logo}
        logoAlt={brandingConfig.title}
        onLogoClick={() => {
          navigate({ to: "/c", search: (prev: any) => prev });
        }}
        whatsappNumber={restaurant?.phone || brandingConfig.phoneNumber || ""}
      />
      <CheckOut />
      <CheckoutFooter />
    </AppLayout>
  );
}
